<script setup lang="ts">
const { value: wantGrocery } = useField('wantGrocery')

const state = computed(() => {
  const state = states.find((state) => state.code === ip.lookup?.stateCode)
  if (state && state.minOtc !== null && state.minOtcLtd) {
    return {
      code: state.code,
      name: state.name,
      minOtc: `$${state.minOtc}`,
      minOtcLtd: `$${state.minOtcLtd}`,
    }
  }
})
</script>

<template>
  <FormProgress class="!mb-6" />

  <div class="text-3xl sm:text-4xl text-center">
    <template v-if="state">
      ¿Quieres {{ state.minOtcLtd }} al año o más para ayudar a pagar por
      alimentos y productos de venta libre?
    </template>
    <template v-else>
      ¿Quieres buscar planes con beneficios adicionales?
    </template>
  </div>

  <div class="grid grid-cols-2 gap-4">
    <Button
      wide
      size="sm"
      type="submit"
      variant="darkBlue"
      @click="wantGrocery = true"
    >
      Sí
    </Button>
    <Button
      wide
      size="sm"
      type="submit"
      variant="darkBlue"
      @click="wantGrocery = false"
    >
      No
    </Button>
    <Button
      wide
      size="sm"
      type="submit"
      variant="gray"
      class="col-span-2"
      @click="wantGrocery = null"
    >
      Omitir
    </Button>
  </div>
</template>
